/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CreateStudents,
  CreateStudentsFromJSON,
  CreateStudentsToJSON,
} from './'

/**
 *
 * @export
 * @interface CreateStudent
 */
export interface CreateStudent {
  /**
   * List of students created
   * @type {Array<CreateStudents>}
   * @memberof CreateStudent
   */
  createStudents: Array<CreateStudents>
}

export function CreateStudentFromJSON(json: any): CreateStudent {
  return CreateStudentFromJSONTyped(json, false)
}

export function CreateStudentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateStudent {
  if (json === undefined || json === null) {
    return json
  }
  return {
    createStudents: (json['createStudents'] as Array<any>).map(
      CreateStudentsFromJSON
    ),
  }
}

export function CreateStudentToJSON(value?: CreateStudent | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    createStudents: (value.createStudents as Array<any>).map(
      CreateStudentsToJSON
    ),
  }
}
